import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragIndicator } from '@mui/icons-material'; // Ícono de arrastre
import { Box, Typography, IconButton } from '@mui/material'; // Componentes de MUI
interface SortableItemProps {
    id: string | number;
    children: React.ReactNode;
    height?: number; // Prop para la altura
}
const SortableItem: React.FC<SortableItemProps> = ({ id, children, height = 70  }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        border: '1px solid #ddd', // Borde para cada registro
        borderRadius: '4px', // Bordes redondeados
        marginBottom: '4px', // Espacio entre registros
        backgroundColor: '#fff', // Fondo blanco
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes}>
            <Box display="flex" alignItems="center" justifyContent="space-between" p={2} height={height} >
                {/* Contenido del registro */}
                <Box flex={1}>
                    {children}
                </Box>
                {/* Botón de arrastre */}
                <IconButton
                    {...listeners}
                    size="small"
                    sx={{
                        cursor: 'grab',
                        marginRight: '8px',
                        '&:hover': { backgroundColor: '#f0f0f0' }, // Efecto hover
                    }}
                >
                    <DragIndicator sx={{ color: '#666' }} /> {/* Color del ícono */}
                </IconButton>

            </Box>
        </div>
    );
};

export default SortableItem;